import acceptedAllConsent from '../actions/acceptedAllConsent';
import EVENT_ACTIONS from '../constants/EVENT_ACTIONS';
import navigateToConsentPage from '../actions/navigateToConsentPage';
import attachEventTrackingToLinks from './attachEventTrackingToLinks';
import refuseConsent from '../actions/refuseConsent';

export const noop = () => Promise.resolve();

/**
 * Attaches event listeners to the accept button, manage button and
 * all links with the class `.gdpr-consent-page-link`
 * @param gdprConsentString
 */
const attachEventListeners = (gdprConsentString) => {
  const acceptButton = document.getElementById('gdpr-consent-banner-accept-button');
  const manageButton = document.getElementById('gdpr-consent-banner-manage-button');
  const acceptConsentExplicit = acceptedAllConsent(gdprConsentString, EVENT_ACTIONS.EXPLICIT_CONSENT_GIVEN);

  const refuseButtons = document.querySelectorAll('.gdpr-consent-button-refuse');

  if (acceptButton) {
    acceptButton.addEventListener('click', acceptConsentExplicit);
  }

  if (manageButton) {
    manageButton.addEventListener('click', navigateToConsentPage);
  }

  if (refuseButtons.length > 0) {
    refuseButtons.forEach((refuseButton) => {
      refuseButton.addEventListener('click', () => {
        refuseConsent(gdprConsentString, EVENT_ACTIONS.REFUSED_CONSENT);
      });
    });
  }
  /**
   * Setup GA Events for each link in the cookie banner
   */
  attachEventTrackingToLinks();
};

export default attachEventListeners;
